import * as angular from "angular";
import {IController} from "angular";
import * as _ from "lodash";

export class podsSettingsTableCtrl implements IController {

  actions: any[];
  selectedActions: any[];
  onActionsChange: Function;

  public selectedKeys: Object;


  $onInit() {
    this.selectedKeys = {};
    _.forEach(this.selectedActions, (a) => {
      this.selectedKeys[a.type] = true;
    })
  }

  onActionClicked(clickedAction) {
    if (this.selectedKeys[clickedAction.type]) {
      this.selectedActions.push(clickedAction);
    } else {
      _.remove(this.selectedActions, (action) => {
        return action.type == clickedAction.type;
      })
    }
    this.onActionsChange({actions: this.selectedActions})
  }

  onMandatoryChanged(changedAction) {
    let action = _.find(this.selectedActions, (action) => {
      return action.type === changedAction.type;
    })
    action.mandatory = changedAction.mandatory;
    this.onActionsChange({actions: this.selectedActions});
  }

}

angular
  .module('bringoz.admin.action-reasons')
  .component('podsSettingsTable', {
    bindings: {
      actions: '<?',
      selectedActions: '<?',
      onActionsChange: '&'
    },
    template: require('./pods-settings-table.html').default,
    controller: podsSettingsTableCtrl
  });
